import { UserAccessRolesEnum } from '@/app/services/auth/auth.types';

/**
 * Roles that can open support admin (/support-admin).
 * Restricted to internal staff — Shout Agency User, plus GodMode as a superadmin
 * safety net. Campaign Manager / Account Manager are excluded because Campaign
 * Manager is part of every user's default roles.
 */
export const SUPPORT_ADMIN_ROLES: UserAccessRolesEnum[] = [
  UserAccessRolesEnum.GodMode,
  UserAccessRolesEnum.ShoutAgencyUser,
];

export function hasSupportAdminAccess(
  roles: Array<UserAccessRolesEnum | number> | null | undefined,
): boolean {
  if (!Array.isArray(roles) || roles.length === 0) {
    return false;
  }
  return SUPPORT_ADMIN_ROLES.some((role) => roles.includes(role));
}

/** Internal Shout Agency staff who may un-hire after a creator has Started. */
export function isShoutAgencyAdmin(
  roles: Array<UserAccessRolesEnum | number> | null | undefined,
): boolean {
  if (!Array.isArray(roles) || roles.length === 0) {
    return false;
  }
  return (
    hasSupportAdminAccess(roles) ||
    roles.includes(UserAccessRolesEnum.CreatorAdmin)
  );
}
